import React from "react";

/* ============================================================================
   Iconos de los selectores de Historia Clínica.

   Trazo, no relleno, para que hereden `currentColor` y funcionen igual en los
   tres temas. 22px es el tamaño de la caja del PickerModal.
   ========================================================================== */

const base = (size) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
});

export function IconoImagen({ size = 22 }) {
  return (
    <svg {...base(size)}>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <circle cx="12" cy="12" r="3.5" />
      <path d="M3 9h2M19 9h2M3 15h2M19 15h2" />
    </svg>
  );
}

export function IconoLaboratorio({ size = 22 }) {
  return (
    <svg {...base(size)}>
      <path d="M9 3h6M10 3v7.5L5.6 18a2 2 0 0 0 1.7 3h9.4a2 2 0 0 0 1.7-3L14 10.5V3" />
      <path d="M7.2 15h9.6" />
    </svg>
  );
}

export function IconoInterconsulta({ size = 22 }) {
  return (
    <svg {...base(size)}>
      <path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8c-1.4 2.9-4.6 4.7-8.1 4.7a9.3 9.3 0 0 1-2.6-.4L4 21l1.4-4.2A8.2 8.2 0 0 1 4 12c0-4.5 3.8-8 8.4-8S21 7 21 11.5z" />
    </svg>
  );
}

export function IconoExterno({ size = 22 }) {
  return (
    <svg {...base(size)}>
      <path d="M14 4h6v6" />
      <path d="M20 4l-8.5 8.5" />
      <path d="M19 14v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5" />
    </svg>
  );
}

export function IconoPermiso({ size = 22 }) {
  return (
    <svg {...base(size)}>
      <path d="M6 3h9l4 4v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M14 3v5h5" />
      <path d="M8.5 14.5l1.8 1.8 3.7-3.9" />
    </svg>
  );
}

export function IconoAsistencia({ size = 22 }) {
  return (
    <svg {...base(size)}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.5V12l3 2" />
    </svg>
  );
}

/** Icono por `Tipo` de la categoría del catálogo, con respaldo genérico. */
export function IconoTipoOrden({ tipo, size = 22 }) {
  const t = String(tipo || "").toUpperCase();
  if (t === "LABORATORIO") return <IconoLaboratorio size={size} />;
  if (t === "INTERCONSULTA") return <IconoInterconsulta size={size} />;
  if (t === "IMAGENES EXTERNAS") return <IconoExterno size={size} />;
  if (t === "PERMISOS") return <IconoPermiso size={size} />;
  if (t === "ASISTENCIA") return <IconoAsistencia size={size} />;
  return <IconoImagen size={size} />;
}

/** Etiqueta legible del `Tipo` — el catálogo los guarda en mayúsculas. */
export function etiquetaTipoOrden(tipo) {
  const t = String(tipo || "").toUpperCase();
  return (
    {
      LABORATORIO: "Laboratorio",
      IMAGENES: "Examen de imagen",
      INTERCONSULTA: "Interconsulta",
      "IMAGENES EXTERNAS": "Imagen externa",
      PERMISOS: "Permiso / reposo laboral",
      ASISTENCIA: "Asistencia a consulta",
    }[t] || tipo || ""
  );
}
